module.exports = __webpack_public_path__ + "img/logo_app.edb628d6.png";